import { get } from './apiUtils'
export const authorize = async (tid) => {
    const auth = await get(`/auth/authorize?tid=${tid}`)
    return auth && auth.data ? auth.data : false
}

export const getsetting = async () => {
    const settings = await get(`/auth/get`)
    return settings 
}
